import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'src/common/utils/browserHistory';
import { ComponentLibraryLoader } from '@unite-us/app-components';
import { datadogRum } from '@datadog/browser-rum';
import { connect } from 'react-redux';
import { BackButton } from 'common/buttons';
import Stepper from 'common/Stepper/Stepper';
import addNotification from 'common/utils/Notifications/actions/AddNotification';
import callOrLog from 'src/common/utils/callOrLog';
import Notifier from 'common/helpers/Notifier';
import { getAuthToken } from 'src/api/config';
import { env } from 'src/config/env';
import getClientsDetailLink from 'src/common/utils/getClientsDetailLink';
import {
  useCreateRecord,
  useFind,
  useFindRecord,
  useInvalidateQueries,
} from 'src/api/APIHooks';
import {
  scrn7ScreeningsCompletion,
  scrn468ScreeningTimeTracking,
} from 'common/utils/FeatureFlags/flags';
import { DrawerContext } from 'src/components/ClientsDrawer/context/DrawerContext';

const ContactDetailsView = ComponentLibraryLoader({
  loadFn: () => import('@unite-us/app-screenings'),
  component: 'ContactScreeningDetailsView',
  source: 'app-screenings',
  loadingApp: 'web-app',
  datadogRum,
});

function ContactScreeningDetailsView({
  params,
  providerId,
  currentEmployee,
  scrn7ScreeningsCompletionEnabled,
  scrn468ScreeningTimeTrackingEnabled,
}) {
  const { handleToggleDrawer } = useContext(DrawerContext);

  return (
    <ContactDetailsView
      source="web_app"
      appState={{
        template_id: params.assessment_id,
        id: params.id,
        providerId,
        currentEmployee,
        getAuthToken,
      }}
      appSettings={{
        env: {
          getAuthToken,
          coreUrl: env.CORE_API,
          screeningsApiUrl: `${env.SCREENING_BASE_URL}/v2`,
          employeeId: currentEmployee?.id,
          providerId,
        },
      }}
      callbacks={{
        notify: {
          error: (message) => Notifier.dispatch('error', message),
          success: (message) => Notifier.dispatch('success', message),
          warn: (message) => Notifier.dispatch('warning', message),
        },
        goBack: () => {
          browserHistory.goBack();
        },
        replace: (path) => {
          browserHistory.replace(path);
        },
        pushInHistory: (path) => {
          browserHistory.push(path);
        },
        onContactNameClick: handleToggleDrawer,
        getClientsDetailLink,
      }}
      utils={{ callOrLog, addNotification }}
      components={{ BackButton, Stepper }}
      flags={{
        scrn7ScreeningsCompletionEnabled,
        scrn468ScreeningTimeTrackingEnabled,
      }}
      hooks={{
        useFindRecord,
        useFind,
        useInvalidateQueries,
        useCreateRecord,
      }}
    />
  );
}

const mapStateToProps = (state) => ({
  providerId: state.session.groupId,
  currentEmployee: state.globalState.currentEmployee,
  scrn7ScreeningsCompletionEnabled: scrn7ScreeningsCompletion(state),
  scrn468ScreeningTimeTrackingEnabled: scrn468ScreeningTimeTracking(state),
});

ContactScreeningDetailsView.propTypes = {
  params: PropTypes.object,
  providerId: PropTypes.string.isRequired,
  currentEmployee: PropTypes.object.isRequired,
  scrn7ScreeningsCompletionEnabled: PropTypes.bool.isRequired,
  scrn468ScreeningTimeTrackingEnabled: PropTypes.bool.isRequired,
};

ContactScreeningDetailsView.defaultProps = {
  params: {},
};
export default connect(mapStateToProps)(ContactScreeningDetailsView);
